<template lang="pug">
  .cover_global(v-if="flag")
    .cover_con
      i.el-icon-close(@click="coverFn")
      //- span.glyphicon.glyphicon-remove(@click="coverFn")
      .cover_form
        p 服务咨询
        .form_li
          img(src="@/assets/img/icon_name.png")
          input(type="text" class="form-control" placeholder="您的称呼" v-model="form.customer_name")
          span.warning(v-show="show.customer_name") 请输入您的称呼
        .form_li
          img(src="@/assets/img/icon_tele.png")
          input(type="text" class="form-control" placeholder="您的联系电话" v-model="form.customer_telephone" @blur="onCheck")
          span.warning(v-show="show.customer_telephone") 请输入您的联系电话
          span.warning(v-show="show.tel_warning") 请输入正确的手机号码
        .form_li
          img(src="@/assets/img/icon_company.png")
          input(type="text" class="form-control" placeholder="您的单位名称" v-model="form.customer_unit")
          span.warning(v-show="show.customer_unit") 请输入您的单位名称
        .cover_btn(@click="submit") 立即提交
</template>
<script>
import api from '../api/api'
export default {
  name: "cover",
  props: {
    flag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: {
        customer_name: false,
        customer_telephone: false,
        customer_unit: false,
        tel_warning: false
      },
      form: {
        customer_name: '',
        customer_telephone: '',
        customer_unit: '',
        from: 'PC',
        from_page: '',
        from_page_title: '弹框'
      }
    };
  },
  watch: {
    flag(){
      if(this.flag){
        this.show = {
          customer_name: false,
          customer_telephone: false,
          customer_unit: false
        }
        this.form = {
          customer_name: '',
          customer_telephone: '',
          customer_unit: '',
          from: 'PC',
          from_page: '',
          from_page_title: '弹框'
        }
      }
    }
  },
  methods: {
    coverFn() {
      this.$emit('change', false);
    },
    async submit(){
      this.form.from = this.$h5 ? 'H5' : 'PC'
      this.show.customer_name = this.form.customer_name == '';
      this.show.customer_telephone = this.form.customer_telephone == '';
      this.show.customer_unit = this.form.customer_unit == '';
      if(this.show.customer_name || this.show.customer_telephone || this.show.customer_unit) return;
      if(this.show.tel_warning) return
      let res = await api.boiCreate(this.form)
      if(res.error_code == 0){
        this.$message.success('提交成功');
        this.reset()
        this.coverFn()
      } else {
        this.$message.error(res.error_message);
      }
    },
    onCheck() {
      var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      var result = re.test(this.form.customer_telephone); 
      if(!result) {
        this.show.tel_warning = true
      } else {
        this.show.tel_warning = false
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.cover_global {
  z-index: 999999999;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  .cover_con {
    position: fixed;
    width: 526px;
    height: 329px;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: #FFFFFF;
    i {
      position: absolute;
      right: 13px;
      top: 13px;
      cursor: pointer;
      font-size: 20px;
      color: #8994A7;
    }
    .cover_form {
      width: 370px;
      height: 280px;
      // background: red;
      margin: 25px auto;
      p {
        font-size: 26px;
        color: #00387D;
        text-align: center;
        font-weight: bold;
      }
      .form_li {
        position: relative;
        img {
          position: absolute;
          width: 20px;
          height: 20px;
          left: 18px;
          top: 8px;
        }
        input {
          height: 36px;
          border: 1px solid #DFDFDF;
          border-radius: 0px;
          margin-top: 20px;
          padding-left: 45px;
        }
        .warning {
          position: absolute;
          left: 0;
          bottom: -18px;
          font-size: 12px;
          color: red;
          top: auto;
        }
      }
      .cover_btn {
        color: white;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        width: 110px;
        height: 36px;
        line-height: 36px;
        background: #00387D;
        margin: 25px auto;
        cursor: pointer;
      }
    }
  }
}
@media(max-width: 768px){
  .cover_global {
    .cover_con {
      width: 86.9%;
      .cover_form {
        width: 85%;
      }
    }
   
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cover.vue